import { all, call, put, takeLatest } from "redux-saga/effects";

import {
    STROLLER_REVIEW_PHOTO_FETCH_TRIGGER,
    StrollerReviewPhotoFetchNormalizedResponse,
    StrollerReviewPhotoFetchTriggerAction,
    strollerReviewPhotoFetchApi,
} from "@/mk2/apps/strollers/containers/StrollerReviewPhoto/StrollerReviewPhoto.actions";
import { XHRAction, XHRGetError, handleXHRGetErrorSaga, normalizeError } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { strollers_api_v2_reviews_photos_get_url } from "@/mk/urls/functions";

const logger = getLogger("strollers/StrollerReviewPhoto.sagas");

interface FetchApiResponse {
    body: StrollerReviewPhotoFetchNormalizedResponse;
}

function* fetchStrollerReviews({
    strollerSlug,
    reviewId,
    xhr,
}: StrollerReviewPhotoFetchTriggerAction & XHRAction) {
    yield put(strollerReviewPhotoFetchApi.request(strollerSlug, reviewId));

    try {
        const response: FetchApiResponse = yield call(() =>
            xhr.get(strollers_api_v2_reviews_photos_get_url({ strollerSlug, reviewId })),
        );

        yield put(strollerReviewPhotoFetchApi.success(strollerSlug, reviewId, response.body));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(
            strollerReviewPhotoFetchApi.failure(strollerSlug, reviewId, normalizeError(error)),
        );
    }
}

export default function* root() {
    yield all([takeLatest(STROLLER_REVIEW_PHOTO_FETCH_TRIGGER, fetchStrollerReviews)]);
}
